// phonics_data_lt25.js
// Letter Teams L25 - L25 Silent Letters wr, kn
// 路由：/phonics/lt25

const MEDIA_BASE = '/media/phonics/lt25';
const V = 'v1';

export const letterDataLt25 = {
  id: 'lt25',
  letter: 'L25',
  title: 'L25 Silent Letters wr, kn',
  mediaBase: MEDIA_BASE,

  part1Video: { src: `${MEDIA_BASE}/part1.mp4?${V}` },
  part3Video: { src: `${MEDIA_BASE}/part3.mp4?${V}` },
  reviewPic: { src: `${MEDIA_BASE}/review.png?${V}` },

  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "The pals will have a party.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "Green writes a note.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "Red gives it to the knight.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "Green bakes a big cake.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "He cuts it with a knife.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "Pink knits with yarn.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "I knit a pretty scarf.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "Yellow puts it in a box.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "I will wrap the box!", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "Blue makes a wreath.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "That's a nice wreath.", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
        { en: "The pals write on a card.", audioEn: `${MEDIA_BASE}/story2_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Knock! Knock!", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "Blue turns the knob.", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "It's the knight!", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "Is this party for me?", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "Yes!", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "Thank you!", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
        { en: "They all eat cake.", audioEn: `${MEDIA_BASE}/story3_7.mp3?${V}` },
      ],
    },
  ],
};
